import React from "react";
import ChannelModal from "./../components/Modals/Channel/ChannelModal";
import PrivacyPolicy from "./../components/Footer/Modals/PrivacyPolicy";
import TermsofService from "./../components/Footer/Modals/TermsofService";
import ChannelUnsplash from "./../components/Modals/Unsplash/ChannelUnsplash";
import TopicModal from "./../components/Modals/Topic/TopicModal";
import ChannelShareModal from "./../components/Modals/share/channelShareModal";
import ChannelCoverModal from "./../components/Modals/Channel/ChannelCoverModal";
import DocumentModal from "./../components/Modals/widgets/DocumentModal";
import LogoutModal from "./../components/Modals/LogoutModal";
import DeleteChatModal from "./../components/Modals/deletions/chatDeleteModal";
import FeedbackModal from "./../components/Modals/FeedbackModal";
import ShareModal from "./../components/Modals/share/ShareModal";
import TopicShareModal from "./../components/Modals/share/topicShareModal";
import TopicReorderModal from "./../components/Modals/Topic/TopicReorderModal";
import EventModal from "./../components/Modals/Event/EventModal";
import RemoveMemberModal from "./../components/Modals/deletions/removeMemberModal";
import EventUnsplashModal from "./../components/Modals/Unsplash/EventUnsplashModal";
import EventCardModal from "./../components/Modals/Event/EventCardModal";
import DeleteEventModal from "./../components/Modals/deletions/eventDeletionModal";
import EmbedLogoutModal from "./../components/Modals/EmbedLogoutModal";
import DeleteDMModal from "./../components/Modals/deletions/dmDeleteModal";
import EventShareModal from "./../components/Modals/share/eventShareModal";
import PollModal from "./../components/Modals/Poll/PollModal";
import DeleteChannelModal from "../components/Modals/deletions/channelDeleteModal";
import DeleteTopicModal from "../components/Modals/deletions/topicDeleteModal";
import LeaveChannelModal from "../components/Modals/deletions/leaveChannelModal";

const Modals = () => (
  <>
    <ChannelModal />
    <PrivacyPolicy />
    <TermsofService />
    <ChannelUnsplash />
    <TopicModal />
    <ChannelShareModal />
    <ChannelCoverModal />
    <DocumentModal />
    <LogoutModal />
    <DeleteChatModal />
    <FeedbackModal />
    <ShareModal />
    <TopicShareModal />
    <TopicReorderModal />
    <EventModal />
    <RemoveMemberModal />
    <EventUnsplashModal />
    <EventCardModal />
    <DeleteEventModal />
    <EmbedLogoutModal />
    <DeleteDMModal />
    <EventShareModal />
    <PollModal />
    <DeleteChannelModal />
    <DeleteTopicModal />
    <LeaveChannelModal />
  </>
);

export default Modals;
